import { useMemo } from "react";
import { CHECKOUT_URL } from "../constants/content";

const FORWARDED_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "gclid",
  "ttclid",
];

export const useCheckoutUrl = () => {
  return useMemo(() => {
    if (typeof window === "undefined") return CHECKOUT_URL;
    const incoming = new URLSearchParams(window.location.search);
    const forwarded = new URLSearchParams();
    FORWARDED_PARAMS.forEach((key) => {
      const value = incoming.get(key);
      if (value) forwarded.set(key, value);
    });
    const query = forwarded.toString();
    return query ? `${CHECKOUT_URL}?${query}` : CHECKOUT_URL;
  }, []);
};
